<template>
  <div>

    <el-tabs style="padding-left: 0px" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户协议" name="first">
        <SettingAgreementItem :agreementType="userAgreement"></SettingAgreementItem>
      </el-tab-pane>
      <el-tab-pane label="隐私协议" name="second">
        <SettingAgreementItem :agreementType="privacyAgreement"></SettingAgreementItem>
      </el-tab-pane>
      <el-tab-pane label="访客须知" name="third">
        <SettingAgreementItem :agreementType="visitorAgreement"></SettingAgreementItem>
      </el-tab-pane>
      <el-tab-pane label="签到须知" name="come">
        <SettingAgreementItem :agreementType="comeAgreement"></SettingAgreementItem>
      </el-tab-pane>
      <el-tab-pane label="签离须知" name="leave">
        <SettingAgreementItem :agreementType="leaveAgreement"></SettingAgreementItem>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import SettingAgreementItem from "@/pages/systemSetting/SettingAgreementItem.vue";

export default {
  name: "PublicSettig",
  components: {SettingAgreementItem},
  data() {
    return {
      activeName: 'first',

      userAgreement: "USER_AGREEMENT",
      privacyAgreement: "SECRET_AGREEMENT",
      visitorAgreement: "VISITOR_NOTICE",
      comeAgreement: "ENTER_NOTICE",
      leaveAgreement: "LEAVE_NOTICE",
    }
  }, // data
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
}

</script>

<style scoped lang="less">

</style>
